import { render, staticRenderFns } from "./ModalGroup.vue?vue&type=template&id=7d0a847d&scoped=true&"
import script from "./ModalGroup.vue?vue&type=script&lang=js&"
export * from "./ModalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0a847d",
  null
  
)

export default component.exports